import Layout from '@/views/layout'

export default [
  {
    path: '/promotionAudit',
    name: 'promotionAudit',
    redirect: '/promotionAudit/myPromotion',
    component: Layout,
    meta: {
      title: '审核中心',
      icon: 'audit.png',
      index: 14
    },
    children: [
      {
        path: 'myPromotion',
        name: 'myPromotion',
        meta: {
          title: '审核中心',
          id: '1628236410',
          trackName: '审核中心'
        },
        component: () => import('@/views/marketPromotion/myPromotion')
      },
    ]
  },
  {
    path: '/oneKeyToOil',
    name: 'oneKeyToOil',
    redirect: '/oneKeyToOil/index',
    component: Layout,
    meta: {
      title: '一键叫油',
      icon: 'oneKeyToOil.png',
      index: 15
    },
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '一键叫油',
          id: 1632832573
        },
        component: () => import('@/views/oneKeyToOil/index')
      }
    ]
  }
]